import React, { useEffect, useState, useContext, useRef } from 'react';
import './LookAround.scss';
import TimelineText from '@/v2/components/atoms/TimelineText';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import TouchIndicator from '@/v2/components/atoms/Icon/TouchIndicator';
import Button from '@/v2/components/atoms/Button';
import Tap from '@/v2/components/atoms/Icon/Tap';
import TextBottom from '@/v2/components/atoms/TextBottom';
import Header from '@/v2/components/application/Header';
// import SwipeRight from '@/v2/components/atoms/Icon/SwipeRight';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { DesignContext } from '@/v2/state/providers';
import { MomentStateContext } from '@/v2/state/momentState';
import { AnalyticsContext } from '@/v2/components/application/Analytics';
import { ClearMemory } from '@/v2/components/utils/DeviceUtils';
import { timeout, clearTimeouts } from '@/v2/components/utils/Timeout';

let videoController = null;

const videoReady = (controller, onReady, setTime) => {
    videoController = controller;
    videoController.AddOnTimeUpdated(() => {
        setTime(videoController.GetTime());
    });

    onReady();
};

const play = (videoStartedOnce, setVideoStartedOnce) => {
    if (videoStartedOnce) return;

    setVideoStartedOnce(true);

    videoController.Play();
};

const videoEnded = (setVideoFinished) => {
    setVideoFinished(true);
};

const activate = () => {};

export default ({ isActive, data, onFinished, onReady }) => {
    const [videoStartedOnce, setVideoStartedOnce] = useState(false);
    const [videoFinished, setVideoFinished] = useState(false);
    const [endScene, setEndScene] = useState(false);
    const [hideTouchIcon, setHideTouchIcon] = useState(false);
    const [{ disclaimer }] = useContext(DesignContext);
    const { dispatch: momentDispatch } = useContext(MomentStateContext);
    const { trackEvent } = useContext(AnalyticsContext);

    const time = useRef(TimelineText.Time());

    let animate = '';

    if (isActive) {
        activate();
        animate = 'in';
    }

    if (videoStartedOnce) {
        animate = 'out';
    }

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => videoReady(controller, onReady, time.current.Set),
        autoPlay: false,
        onFinished: () => videoEnded(setVideoFinished),
    };

    const proceedToExploreFeatures = () => {
        setHideTouchIcon(true);
        play(videoStartedOnce, setVideoStartedOnce);
        trackEvent('vcClick', {
            vcStep: 'look around',
            vcClick: 'hotspot:explore features',
        });
    };

    const touchIndictator = !hideTouchIcon ? (
        <div className="LookAround__tap" onClick={proceedToExploreFeatures} onKeyDown={proceedToExploreFeatures} role="button" tabIndex="0">
            <TouchIndicator />
        </div>
    ) : (
        ''
    );

    const sceneEnds = () => {
        setEndScene(true);

        timeout(() => {
            onFinished();
            ClearMemory();
        }, 2000);
    };

    const headerContent = <Header show={isActive} hideLogo />;
    const disclaimerContent = isActive && disclaimer ? <Disclaimer data={disclaimer} /> : '';

    useEffect(() => () => clearTimeouts(), []);

    useEffect(() => {
        if (isActive && videoController) {
            videoController.ProgressDispatch(momentDispatch);
        }
    }, [isActive, videoController]);

    return (
        <div className="LookAround">
            <VideoSimple src={data.video} options={options} />
            {headerContent}
            {isActive ? (
                <div className="LookAround__text-container">
                    <TextBottom background="dark" animate={animate} color="white" component="h4">
                        {data.text.cta.lookAround}
                        <span className="LookAround__text__icon">
                            <Tap loop={false} />
                        </span>
                    </TextBottom>
                    <TimelineText data={data.text.timeline} time={time.current} />
                </div>
            ) : (
                ''
            )}

            {touchIndictator}

            {videoFinished ? (
                <div className="LookAround__cta">
                    <Button
                        variant="primary-light"
                        animate={endScene ? 'out' : 'in'}
                        onClick={() => {
                            sceneEnds(onFinished, setEndScene);
                        }}
                    >
                        {data.text.cta.explore}
                    </Button>
                </div>
            ) : (
                ''
            )}
            {endScene ? <div className="LookAround__fadeOut" /> : ''}
            {disclaimerContent}
        </div>
    );
};
